
import {Swiper, SwiperSlide} from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

const categories = [
    {
        name: 'Женщинам',
        url: '/catalog/tennisnaya_odezhda/?gender=female',
        image: '/assets/img/category_tennisnaya_odezhda_female.webp',
        image2x: '/assets/img/category_tennisnaya_odezhda_female@2x.webp',
    },
    {
        name: 'Мужчинам',
        url: '/catalog/tennisnaya_odezhda/?gender=male',
        image: '/assets/img/category_tennisnaya_odezhda_male.webp',
        image2x: '/assets/img/category_tennisnaya_odezhda_male@2x.webp',
    },
    {
        name: 'Детям',
        url: '/catalog/detskaya_odezhda/',
        image: '/assets/img/category_detskaya_odezhda.webp',
        image2x: '/assets/img/category_detskaya_odezhda@2x.webp',
    },
    {
        name: 'Ракетки',
        url: '/catalog/raketki/',
        image: '/assets/img/category_raketki.webp',
        image2x: '/assets/img/category_raketki@2x.webp',
    },
    {
        name: 'Обувь',
        url: '/catalog/tennisnaya_obuv/',
        image: '/assets/img/category_obuv.webp',
        image2x: '/assets/img/category_obuv@2x.webp',
    },
];

export default {
    name: 'HomeCategories',
    components: {
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            categories,
            swiperOptions: {
                preloadImages: false,
                slidesPerView: 'auto',
                spaceBetween: 10,
                watchOverflow: true,
                scrollbar: {
                    el: '.home-categories__scrollbar',
                    draggable: true,
                    dragSize: 56,
                    hide: false,
                },
                breakpoints: {
                    1024: {
                        slidesPerView: 5,
                        spaceBetween: 5,
                        allowTouchMove: false,
                        scrollbar: {dragSize: 'auto'},
                    },
                },
                on: {
                    breakpoint(params) {
                        // Swiper 5 retains desktop widths when returning to auto sizing.
                        if (params.slidesPerView === 'auto' && this.slides) {
                            this.slides.each((index, slide) => {slide.style.width = '';});
                        }
                    },
                },
            },
        }
    },
    methods: {
        slidePrev() {
            if (this.$refs.categoriesSwiper && this.$refs.categoriesSwiper.$swiper) {
                this.$refs.categoriesSwiper.$swiper.slidePrev();
            }
        },
        slideNext() {
            if (this.$refs.categoriesSwiper && this.$refs.categoriesSwiper.$swiper) {
                this.$refs.categoriesSwiper.$swiper.slideNext();
            }
        },
    },
}
